import React, { useState, useEffect } from 'react';
import { StatisticDataVO } from '@/types/camp/admin/statisticDataType';
import { Flex, Progress } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import styles from '@/pages/camp/components/css/campCSS.less';

interface Props {
  data?: StatisticDataVO;
}
const TopCard: React.FC<Props> = ({ data }) => {
  const [options, setOptions] = useState<{}>();
  const [valueList, setValueList] = useState<string[]>();
  const [totalList, setTotalList] = useState<string[]>();
  const [dataHeight, setDataHeight] = useState<number>(0);

  return (
    <div className={styles.statistics_top_card} style={{ marginBottom: 24 }}>
      <div className={styles.top_card_item}>
        <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
          <span>报名情况</span>
        </div>

        <div className={styles.info_item}>
          <div>
            <span className="f20 fw600 col008">{data?.signUpNum}</span>
            <span className="f14 col808"> 人报名</span>
          </div>
          <div>
            <span className="f20 fw600 col008">{data?.finishCampNum}</span>
            <span className="f14 col808"> 人结营</span>
          </div>
          <div>
            <span className="f14 col808">结营率：</span>
            <span className="f20 fw600 col008">
              {data?.finishCampNum ? ((data?.finishCampNum / data?.signUpNum) * 100).toFixed(2) : 0}
              %
            </span>
          </div>
        </div>
        <div>
          <Flex gap="small" vertical>
            <Progress
              percent={data?.finishCampNum ? (data?.finishCampNum / data?.signUpNum) * 100 : 0}
              showInfo={false}
              strokeColor="#0087FC"
            />
          </Flex>
        </div>
      </div>
      <div className={styles.top_card_item}>
        <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
          <span>视频观看情况</span>
        </div>

        <div className="flex_3">
          <div>
            <span className="f20 fw600 col008">{data?.videoPlayNum}</span>
            <span className="f14 col808"> 人观看视频</span>
          </div>
          <div>
            <span className="f14 col808">观看率：</span>
            <span className="f20 fw600 col008">
              {data?.videoPlayNum ? ((data?.videoPlayNum / data?.signUpNum) * 100).toFixed(2) : 0}%
            </span>
          </div>
        </div>
        <div>
          <Flex gap="small" vertical>
            <Progress
              percent={data?.videoPlayNum ? (data?.videoPlayNum / data?.signUpNum) * 100 : 0}
              showInfo={false}
              strokeColor="#0087FC"
            />
          </Flex>
        </div>
      </div>
      <div className={styles.top_card_item}>
        <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
          <span>开始打卡情况</span>
        </div>

        <div className="flex_3">
          <div>
            <span className="f20 fw600 col008">{data?.startCampNum}</span>
            <span className="f14 col808"> 人开始打卡</span>
          </div>
          <div>
            <span className="f14 col808">开始打卡率：</span>
            <span className="f20 fw600 col008">
              {data?.startCampNum ? ((data?.startCampNum / data?.signUpNum) * 100).toFixed(2) : 0}%
            </span>
          </div>
        </div>
        <div>
          <Flex gap="small" vertical>
            <Progress
              percent={data?.startCampNum ? (data?.startCampNum / data?.signUpNum) * 100 : 0}
              showInfo={false}
              strokeColor="#0087FC"
            />
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default TopCard;
